import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { V2_SIGNUP_PATH } from "v2/constants/signupPaths";
import { useSignupResumeState } from "v2/utils/useSignupResumeState";

export const SignupResumeRedirect = () => {
  const history = useHistory();
  const { isSignupPending, isChecking } = useSignupResumeState();

  useEffect(() => {
    if (isChecking || !isSignupPending) return;

    history.replace(V2_SIGNUP_PATH);
  }, [isChecking, isSignupPending, history]);

  return null;
};
